exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-connections-connected{color:#5cb85c !important}.admin-connections-temp-disconnected{color:orange !important}.admin-connections-counter{opacity:.5}.admin-connections-refresh:hover{cursor:pointer;opacity:.8}.admin-connections-help:hover{cursor:help}.admin-connections-disconnected{color:#d9534f !important}.admin-connections-failed{color:#d9534f !important;font-weight:bold}.admin-connections-slash{opacity:.5;margin-left:.2rem;margin-right:.2rem}.admin-connections-info{margin-top:1rem}.admin-connections-restart-warning{color:#ffd43b;margin-left:.5rem}.admin-connections-restart-warning:hover{cursor:help}\n", ""]);

// exports
